module.exports = __webpack_public_path__ + "img/icon_refresh.00ccf23a.svg";